<template>
  <div class="map" :id="id">
  </div>
</template>

<script>
import { Line, Column, Pie, Area, Funnel, Bar, Radar, DualAxes, Rose, Sankey, G2 } from '@antv/g2plot'
import * as echarts from 'echarts'
import china from '@/assets/map/json/china.json'
import _ from 'lodash'
export default {
  name: 'Map',
  props: {
    id: {
      type: [Number, String],
      default: new Date().getTime()
    },
    config: {
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    chartData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    let thatV = this
    return {
      chart: null,
      options: {
        tooltip: {
          triggerOn: 'mousemove', // mousemove、click
          padding: 8,
          borderWidth: 1,
          borderColor: '#409eff',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000000',
            fontSize: 13
          },
          formatter: null
          // formatter: function (e, t, n) {
          //   let data = e.data
          //   let context
          //   if (data) {
          //     context = `
          //    <div>
          //         <p>${data.name}</p>
          //         <p>${thatV.numberSplitWithComma(data.value)}</p>
          //    </div>
          //    `
          //   }
          //   return context
          // }
        },
        visualMap: {
          show: false,
          min: 0,
          max: 100000000,
          text: ['High', 'Low'],
          realtime: false,
          calculable: true,
          inRange: {
            color: ['green', 'yellow', 'red']
          },
          bottom: 0,
          textStyle: {
            color: '#fff'
          },
          formatter (e) {
            return `${thatV.numberSplitWithComma(e)}`
          }
        },
        geo: {
          map: 'china',
          center: [104.97, 39.71],
          // center: ['50%', '50%'],
          // scaleLimit: {
          //   min: 1,
          //   max: 2
          // },
          zoom: 1.2,
          top: 0,
          label: {
            normal: {
              show: true,
              fontSize: '11',
              color: '#fff',
              formatter: function (e) {
                let item = thatV.options.series[0].data.find(item => item.name === e.name)
                if (item) {
                  let allrevenueVal = item.value
                  allrevenueVal = parseInt(allrevenueVal)
                  return `${item.name}\n${allrevenueVal}`
                }
                return e.name
              }
            }

          },
          itemStyle: {
            normal: {
              // shadowBlur: 50,
              // shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: 'rgba(0, 0, 0, 0.2)'

            },
            emphasis: {
              areaColor: '#f2d5ad',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            type: 'map',
            geoIndex: 0,
            data: [...thatV.chartData]
          }
        ]
      }
    }
  },
  computed: {

  },
  created () {
    this.$bus.$on('chinaMap', this.checkTypeHandler)
    this.$once('hook:beforeDestory', () => {
      this.$bus.$off('chinaMap')
    })
  },
  mounted () {
    this.initEchartMap()
  },
  watch: {
    config: {
      deep: true,
      immediate: true,
      handler: function (newV, oldV) {
        this.updateOptions()
      }
    }
  },
  methods: {
    checkTypeHandler (key) {
      this.chart.resize()
    },
    // 初始化中国地图
    initEchartMap () {
      let newOptions = _.cloneDeep(this.config)
      let { inRangeColorA, inRangeColorB, options } = newOptions
      let mapDiv = document.getElementById(this.id)
      echarts.registerMap('china', { geoJSON: china })
      this.chart = echarts.init(mapDiv, {}, { renderer: 'svg' })
      options.series[0].data = this.chartData
      _.set(options, 'visualMap.inRange.color', [inRangeColorA, inRangeColorB])
      let strFormatterFn = _.get(options, 'series[0].label.formatterFn')
      _.set(options, 'series[0].label.formatter', (item) => this.geoLabelFormatter(item, strFormatterFn))
      this.chart.setOption(options)
    },
    updateOptions () {
      if (!this.chart) { return }
      let newOptions = _.cloneDeep(this.config)
      let { inRangeColorA, inRangeColorB, options } = newOptions
      options.series[0].data = this.chartData
      let strFormatterFn = _.get(options, 'series[0].label.formatterFn')
      _.set(options, 'series[0].label.formatter', (item) => this.geoLabelFormatter(item, strFormatterFn))
      this.chart.setOption({
        visualMap: {
          inRange: {
            color: [inRangeColorA, inRangeColorB]
          }
        }
      })
      this.chart.setOption(options)
    },
    geoLabelFormatter (item, strFormatterFn) {
      let data = item
      return strFormatterFn.replace(/{([a-zA-Z]+)}|(\\n|\n)/g, ($1, $2, $3) => {
        if ($2) { return data[$2] }
        if ($3) { return '\r\n' }
      })
    }
  },
  components: {

  }
}
</script>

<style scoped lang="stylus">
.map
  width 100%
  height 100%

</style>
